/**
 * Набор вспомогательных функций для работы с DOM
 */

/**
 * Получает соседние элементы (сиблинги) для указанного элемента
 * @param {Element} element - Целевой элемент
 * @returns {Element[]} Массив соседних элементов
 */
export function getSiblings(element) {
  const children = [...element.parentElement.children];
  return children.filter((child) => child !== element);
}

/**
 * Создает DOM-элемент с указанными параметрами
 * @param {string} tag - Тег элемента
 * @param {string} [className] - CSS класс
 * @param {string} [innerHTML] - HTML содержимое
 * @returns {Element} Созданный элемент
 */
export function createElement(tag, className = '', innerHTML = '') {
  const element = document.createElement(tag);
  if (className) element.className = className;
  if (innerHTML) element.innerHTML = innerHTML;
  return element;
}

/**
 * Находит первый элемент по селектору в пределах корневого элемента
 * @param {Element} root - Корневой элемент для поиска
 * @param {string} selector - CSS селектор
 * @returns {Element|null} Найденный элемент или null
 */
export function findElement(root, selector) {
  return root.querySelector(selector);
}

/**
 * Находит все элементы по селектору в пределах корневого элемента
 * @param {Element} root - Корневой элемент для поиска
 * @param {string} selector - CSS селектор
 * @returns {Element[]} Массив найденных элементов
 */
export function findAllElements(root, selector) {
  return Array.from(root.querySelectorAll(selector));
}

/**
 * Измеряет ширину элемента, временно скрывая его для точного измерения
 * @param {Element} element - Элемент для измерения
 * @returns {number} Ширина элемента в пикселях
 */
export function measureElementWidth(element) {
  const originalDisplay = element.style.display;
  const originalVisibility = element.style.visibility;

  element.style.display = '';
  element.style.visibility = 'hidden';

  const width = element.offsetWidth;

  element.style.display = originalDisplay;
  element.style.visibility = originalVisibility;

  return width;
}

/**
 * Создает debounced-версию функции
 * @param {Function} func - Функция для обертывания
 * @param {number} wait - Время задержки в миллисекундах
 * @returns {Function} Debounced-функция
 */
export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
